import React from 'react';
import { FileIcon } from 'elements/Icon';

const JPG = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z"/>
    <rect x="12.689" y="103.527" width="74" height="24"/>
    <g>
      <polygon points="41.702,37.633 12.621,88 70.781,88 	"/>
      <polygon points="63.295,49.108 40.842,88 85.75,88 	"/>
      <circle cx="78.626" cy="38.701" r="7.124"/>
    </g>
    <g>
      <path fill="#FFFFFF" className="text" d="M32.498,118.949h2.367v2.336h-2.367V118.949z"/>
      <path fill="#FFFFFF" className="text" d="M38.568,116.918v0.266c0.02,0.891,0.111,1.517,0.275,1.879s0.515,0.543,1.053,0.543
        c0.533,0,0.886-0.198,1.057-0.594c0.103-0.234,0.154-0.63,0.154-1.188v-8.055h2.406v8.016c0,0.979-0.166,1.755-0.496,2.328
        c-0.561,0.969-1.571,1.453-3.033,1.453s-2.441-0.392-2.941-1.176c-0.498-0.784-0.748-1.853-0.748-3.207v-0.266h2.273
        C38.568,116.917,38.568,116.918,38.568,116.918z"/>
      <path fill="#FFFFFF" className="text" d="M53.791,116.301c-0.674,0.562-1.637,0.844-2.888,0.844h-2.397v4.141h-2.391V109.77h4.944
        c1.14,0,2.049,0.297,2.727,0.891s1.017,1.513,1.017,2.758C54.802,114.777,54.465,115.738,53.791,116.301z M51.955,112.152
        c-0.305-0.255-0.731-0.383-1.281-0.383h-2.168v3.391h2.168c0.55,0,0.977-0.138,1.281-0.414s0.457-0.714,0.457-1.312
        S52.259,112.407,51.955,112.152z"/>
      <path fill="#FFFFFF" className="text" d="M64.474,113.363c-0.183-0.786-0.628-1.336-1.336-1.648c-0.396-0.172-0.836-0.258-1.32-0.258
        c-0.927,0-1.688,0.35-2.285,1.049s-0.895,1.75-0.895,3.154c0,1.414,0.323,2.414,0.969,3.002c0.646,0.587,1.38,0.881,2.203,0.881
        c0.808,0,1.469-0.231,1.984-0.695c0.516-0.463,0.833-1.069,0.953-1.82h-2.664v-1.922h4.797v6.18h-1.594l-0.242-1.438
        c-0.464,0.545-0.88,0.928-1.25,1.151c-0.636,0.389-1.417,0.583-2.344,0.583c-1.526,0-2.776-0.528-3.75-1.585
        c-1.016-1.062-1.523-2.514-1.523-4.356c0-1.863,0.513-3.357,1.539-4.481s2.383-1.687,4.07-1.687c1.464,0,2.64,0.371,3.527,1.113
        s1.397,1.668,1.527,2.777C66.84,113.363,64.474,113.363,64.474,113.363z"/>
    </g>
  </FileIcon>
);

export default JPG;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/JPG.jsx